import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminLayoutComponent } from './admin-layout.component';
import { HeaderComponent } from './components/header/header.component';
import { LangSelectModule, ProfilePreviewModule } from '../shared/components';
import { RouterModule } from '@angular/router';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [AdminLayoutComponent, HeaderComponent],
  imports: [
    CommonModule,
    LangSelectModule,
    NzButtonModule,
    TranslateModule,
    RouterModule,
    ProfilePreviewModule,
  ],
})
export class AdminLayoutModule {}
